import type { PeriodoCampoOpcao } from '@/shared/types/filtroPeriodo';

import type { NegociacaoPeriodoCampo } from '../types/negociacoesTypes';
import type { TipoEncerramento } from '../types/encerramentoTypes';
import type {
  NegociacaoCloseType,
  NegociacaoTemperature,
  NegociacaoType,
} from '../types/negociacoesUiTypes';

export const statusOptions: string[] = [
  'Aguardando envio',
  'Aguardando resposta',
  'Em negociação',
  'Acordo fechado',
  'Proposta recusada',
  'Interrompida',
  'Pausada',
  'Falha no envio',
];

export const typeOptions: NegociacaoType[] = ['Individual', 'Lote'];

export const temperatureOptions: NegociacaoTemperature[] = ['Quente', 'Morna', 'Fria'];

export const pendencyOptions: string[] = ['Com pendência', 'Sem pendência'];

export const closeTypeOptions: NegociacaoCloseType[] = [
  'Acordo manual',
  'Acordo IA',
  'Desistência',
  'Timeout',
  'Cancelamento',
];

export const closeTypeValueMap: Record<NegociacaoCloseType, TipoEncerramento> = {
  'Acordo manual': 'ACORDO_MANUAL',
  'Acordo IA': 'ACORDO_IA',
  Desistência: 'DESISTENCIA',
  Timeout: 'TIMEOUT',
  Cancelamento: 'CANCELAMENTO',
};

const objectiveLabelMap: Record<string, string> = {
  valores: 'Negociação de valores',
  contrato: 'Formalização de contrato',
  regularizacao: 'Regularização',
  prevencao: 'Comunicação preventiva',
};

const objectiveValueByLabel = Object.entries(objectiveLabelMap).reduce<Record<string, string>>(
  (acc, [value, label]) => {
    acc[label] = value;
    return acc;
  },
  {},
);

export const objectiveOptions: string[] = Object.keys(objectiveLabelMap);

export const resolveObjectiveValue = (objective: string | null | undefined): string | null => {
  if (!objective) {
    return null;
  }

  const normalized = objective.trim();
  if (!normalized) {
    return null;
  }

  if (objectiveLabelMap[normalized]) {
    return normalized;
  }

  const byLabel = objectiveValueByLabel[normalized];
  if (byLabel) {
    return byLabel;
  }

  return normalized;
};

export const resolveObjectiveLabel = (objective: string | null | undefined): string => {
  const value = resolveObjectiveValue(objective);

  if (!value) {
    return 'Negociação';
  }

  return objectiveLabelMap[value] ?? value;
};

export const periodoCampoOptions: readonly (PeriodoCampoOpcao & {
  key: NegociacaoPeriodoCampo;
  /** Cabeçalho da coluna de data quando este campo está filtrado. */
  coluna: string;
})[] = [
  { key: 'criacao', label: 'Criação', long: 'Data de criação', coluna: 'Criada em' },
  {
    key: 'ultimaInteracao',
    label: 'Última interação',
    long: 'Última interação',
    coluna: 'Última interação',
  },
  { key: 'acordo', label: 'Acordo', long: 'Data do acordo', coluna: 'Data do acordo' },
];
